import api from '../lib/api';
import { buildListQuery, type ListQueryInput } from '../lib/buildListQuery';
import type { Distributor, DistributorInput, Paginated } from '../types';

export type ListDistributorsParams = ListQueryInput;

export interface DistributorFilterOptions {
  regions: string[];
  zip_codes: string[];
}

export const distributorService = {
  list: async (params?: ListDistributorsParams): Promise<Paginated<Distributor>> => {
    const response = await api.get<Paginated<Distributor>>('/distributors', { params: buildListQuery(params) });
    return response.data;
  },

  filterOptions: async (): Promise<DistributorFilterOptions> => {
    const response = await api.get<DistributorFilterOptions>('/distributors/filter_options');
    return response.data;
  },

  get: async (id: number): Promise<Distributor> => {
    const response = await api.get<{ data: { attributes: Distributor } }>(`/distributors/${id}`);
    return response.data.data.attributes;
  },

  create: async (data: DistributorInput): Promise<Distributor> => {
    const response = await api.post<{ data: { attributes: Distributor } }>('/distributors', { distributor: data });
    return response.data.data.attributes;
  },

  update: async (id: number, data: DistributorInput): Promise<Distributor> => {
    const response = await api.patch<{ data: { attributes: Distributor } }>(`/distributors/${id}`, { distributor: data });
    return response.data.data.attributes;
  },

  destroy: async (id: number): Promise<void> => {
    await api.delete(`/distributors/${id}`);
  },

  toggleActive: async (id: number): Promise<Distributor> => {
    const response = await api.patch<{ data: { attributes: Distributor } }>(`/distributors/${id}/toggle_active`);
    return response.data.data.attributes;
  },
};

export default distributorService;
